import { FunctionComponent, useMemo } from "react";
import throttle from "lodash.throttle";

import { MapEventType } from "./types";
import useMapEvent from "./use-map-event";

const MapEvent: FunctionComponent<MapEventProps> = ({
  listener,
  throttle: throttleDuration,
  event,
}) => {
  const throttledListener = useMemo(() => {
    if (throttleDuration !== null) {
      return throttle(listener, throttleDuration);
    }
    return listener;
  }, [listener, throttleDuration]);

  useMapEvent(event, throttledListener);

  return null;
};

type MapEventProps = {
  event: MapEventType;
  throttle?: number;
  listener: any;
};

export default MapEvent;
